import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback
} from "react";
import axios from "axios";
import { API } from "../api/auth";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchUser = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await axios.get(`${API.BASE_URL}/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const rawRoles = res.data?.roles;
      const roles = Array.isArray(rawRoles) ? rawRoles : (rawRoles ? [rawRoles] : []);
      setUser({ ...res.data, roles });
    } catch {
      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  const login = useCallback(async (token, refresh = null) => {
    localStorage.setItem("token", token);
    if (refresh) localStorage.setItem("refresh_token", refresh);
    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      const roles = Array.isArray(payload.roles)
        ? payload.roles.map(r => typeof r === "string" ? r : r.authority ?? r.role ?? "")
        : [];
      const userData = { ...payload, roles };
      setUser(userData);
      setLoading(false);
      return userData;
    } catch {
      await fetchUser();
      return null;
    }
  }, [fetchUser]);

  const logout = useCallback(() => {
    localStorage.removeItem("token");
    localStorage.removeItem("refresh_token");
    setUser(null);
    setLoading(false);
    window.location.href = "/";
  }, []);

  useEffect(() => {
    fetchUser();
  }, [fetchUser]);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);